import {
    GET_TYPE_DOCUMENTS_PROVIDER,
    GET_TYPE_DOCUMENTS_PROVIDER_SUCCESS,
    GET_TYPE_DOCUMENTS_PROVIDER_API_ERROR,
} from "./actionTypes"




export const getTypeDocumentsProvider  = data => {
    return {
        type: GET_TYPE_DOCUMENTS_PROVIDER,
        payload: { data }
    }
}


export const getTypeDocumentsProviderSuccess = data => {
    return {
        type: GET_TYPE_DOCUMENTS_PROVIDER_SUCCESS,
        payload: { data }
    }
}

export const apigetTypeDocumentsProviderError = error => {
    return {
        type: GET_TYPE_DOCUMENTS_PROVIDER_API_ERROR,
        payload: { error },
    }
}

